import {
    Button,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import PromoMappingTable from "./PromoMappingTable";
import {
    DRAFT_STATUS,
    LIVE,
    SCHEDULED_STATUS,
} from "../../LandingPage/constants";
import {
    ACTION,
    PERMISSIONS,
    usePermissions,
} from "../../../../utils/permissions";

const ContentCurationVersions = () => {
    const navigate = useNavigate();
    const { hasPermission } = usePermissions();
    const draftTableRef = useRef<any>(null);

    const navigateToPromo = () => {
        navigate("/promo-video-management/create");
    };

    const refreshDraft = () => {
        draftTableRef.current.getMappingList();
    };

    return (
        <div className="config-heading">
            <div className="header-content-list">
                <div>
                    <h3>Promo Video Mappings</h3>
                </div>
                <div className="d-flex j-center">
                    {hasPermission(PERMISSIONS.curation, ACTION.EDIT) && (
                        <Button
                            className="float-right mb-2"
                            onClick={() => navigateToPromo()}
                            variant="contained"
                        >
                            Create Mapping
                        </Button>
                    )}
                </div>
            </div>
            {/* Live Status - Promo Mapping List */}
            <PromoMappingTable
                refreshDraft={refreshDraft}
                status={LIVE}
                showActionButton={false}
            />
            <PromoMappingTable
                refreshDraft={refreshDraft}
                status={SCHEDULED_STATUS}
                showActionButton={false}
            />
            <PromoMappingTable
                ref={draftTableRef}
                status={DRAFT_STATUS}
                showActionButton={false}
            />
        </div>
    );
};

export default ContentCurationVersions;
